import { DrawRequestResp } from "../../../types/draw-request";

export const canBeApprovedOrDenied = (drawRequest: DrawRequestResp | undefined, isPayment: boolean, isTreasury: boolean) => {
    if (!drawRequest) {
        // console.log('if (!drawRequest) return false');
        return false
    }

    if (!isPayment && !isTreasury) {
        // console.log('if (!isAccountant && !isTreasury) return false;');
        return false;
    }

    if (drawRequest.isDraft) {
        // console.log('if (drawRequest.isDraft) return false;');
        return false;
    }

    if (drawRequest.accountingApprovalStatus?.toLowerCase() !== "pending") {
        // console.log(' if (drawRequest.accountingApprovalStatus?.toLowerCase() !== "pending") ');
        return false;
    }

    const approvalStatus = drawRequest.approvalStatus?.toLowerCase();
    if (drawRequest.accountingApprovalStatus?.toLocaleLowerCase() === "approved") {
        // console.log('if (drawRequest.accountingApprovalStatus?.toLocaleLowerCase() === "approved") ');

        return false;
    }

    if (approvalStatus !== "completed") {
        // console.log('  if (approvalStatus !== "completed") ');
        return false;
    }

    const pm = drawRequest?.paymentMethod?.id || undefined;
    if (!pm) {
        // console.log('    if (!pm)');
        return false;
    }

    const isACHCheck = [3, 4, 5].includes(pm);

    // console.log('return isACHCheck ? isAccountant : isTreasury;');

    return isACHCheck ? isPayment : isTreasury;
};

